import styled from 'styled-components';

export const Container = styled.div`
	margin: 0 40px;

	@media (max-width: 600px) {
		margin: 0 15px;
	}
`;

export const AboutUsContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	@media (max-width: 800px) {
		flex-direction: column;
	}

	@media (max-width: 600px) {
		img {
			width: 60px;
			height: 60px;
		}
	}
`;

export const TextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.primaryBlackColor};
	margin: 0 25px;
	width: 38%;

	@media (max-width: 1050px) {
	width: 50%;
	}

	@media (max-width: 800px) {
		width: 100%;
		align-items: center;
		margin: 25px 0;
		    text-align: center;
	}
`;

export const Title = styled.div`
	${({ theme }) => theme.typography.headlineS};
`;
export const SubTitle = styled.sub`
	${({ theme }) => theme.typography.textM};
	width: 76%;
	@media (max-width: 800px) {
		width: 100%;
		margin-top: 8px;
	}
`;
export const ButtonWrapper = styled.div`
	width: 25%;
	@media (max-width: 800px) {
		width: 100%;
	}
`;
